import { createError } from '../../../../../lib/error';

class CalendarWrapperController {

  constructor(
    $scope,
    $q,
    StaffUserService,
    LogService
  ) {
    "ngInject";
    this.$scope = $scope;
    this.$q = $q;
    this.StaffUserService = StaffUserService;
    this.LogService = LogService;
    this.$scope = $scope;
    this._fullCalendarOptions = {
    };
  };

  get fullCalendarOptions() {
    return this._fullCalendarOptions;
  }

  set fullCalendarEvents(events) {
    this._fullCalendarEvents = events;
  }

  get fullCalendarEvents() {
    return this._fullCalendarEvents;
  }
}

export default CalendarWrapperController;
